import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class ClientDetailsUseCase extends BaseUseCase {
    constructor(clientDetailsRep) {
        super();
        this.clientDetailsRep = clientDetailsRep;
    }
    async fetchResult(req) {
        return await this.clientDetailsRep.getClientDetailsData(req);
    }
}
export default ClientDetailsUseCase;
